import { useEffect, useState, useCallback } from 'react';
import * as Font from 'expo-font';
import { myTheme } from '../theme';

const useApp = () => {
  const [fontLoaded, setFontLoaded] = useState(false);

  useEffect(() => {
    async function loadFont() {
      await Font.loadAsync({
        coreSansRegular: require('../../assets/fonts/s-core_-_coresanscr-45regular-webfont.ttf'),
        coreSansBold: require('../../assets/fonts/s-core_-_coresanscr-65bold-webfont.ttf'),
        coreSansExtraBold: require('../../assets/fonts/s-core_-_coresanscr-75extrabold-webfont.ttf'),
        coreSansMedium: require('../../assets/fonts/s-core_-_coresanscr-55medium-webfont.ttf'),
      });
      setFontLoaded(true);
    }
    loadFont();
  }, []);

  const theme = {
    ...myTheme,
  };

  const [temperatureUnit, setTemperatureUnit] = useState<
    'auto' | 'fahrenheit' | 'celsius'
  >(() => {
    const storedValue = window.localStorage.getItem('temperatureUnit');
    return storedValue ? JSON.parse(storedValue) : 'auto';
  });

  // Helper function to determine units based on location
  const getLocationBasedUnit = useCallback((location?: string): boolean => {
    if (!location) return true; // Default to Fahrenheit if no location

    // European and International locations that should use Celsius
    const metricLocations = [
      'monte carlo',
      'rome',
      'lisbon',
      'prague',
      'singapore',
      'lisbon - corinthia',
      'lisbon - epic sana',
      'riviera maya',
    ];

    return !metricLocations.includes(location.toLowerCase());
  }, []);

  const getDisplayUnit = useCallback(
    (location?: string) => {
      if (temperatureUnit === 'auto') {
        return getLocationBasedUnit(location);
      }
      return temperatureUnit === 'fahrenheit';
    },
    [temperatureUnit, getLocationBasedUnit]
  );

  const handleTemperatureUnit = (unit: 'auto' | 'fahrenheit' | 'celsius') => {
    setTemperatureUnit(unit);
    window.localStorage.setItem('temperatureUnit', JSON.stringify(unit));
  };

  return {
    theme,
    fontLoaded,
    temperatureUnit,
    getDisplayUnit,
    handleTemperatureUnit,
  };
};

export default useApp;
